var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72202 20.7782L2.78095 16.3553M2.72202 20.7782L7.14491 20.7192M2.72202 20.7782L8.08598 15.4142M21.2784 2.22182L16.8555 2.28074M21.2784 2.22182L21.2194 6.64471M21.2784 2.22182L15.9144 7.58578",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.278 20.7782L21.2191 16.3553M21.278 20.7782L16.8551 20.7192M21.278 20.7782L15.914 15.4142M2.72163 2.22182L7.14451 2.28074M2.72163 2.22182L2.78055 6.64471M2.72163 2.22182L8.08559 7.58578",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.ecbcd5b2fa27461b533b2a15d38cb125.svg";
export { ForwardRef as ReactComponent };